var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"jumbotron"},[_c('h3',[(_vm.customField)?_c('strong',[_vm._v(_vm._s(_vm.customField))]):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }